export function renderButtonStyle(type: string) {
  switch (type) {
    case "primary":
      return "px-8 py-3 text-lg font-semibold  bg-transparent text-white hover:bg-white shadow-sm transition-colors duration-200 hover:shadow-none";
    case "secondary":
      return "px-8 py-3 text-lg font-semibold border rounded  border-gray-400 hover:bg-white hover:bg-th-btncol-2";
    default:
      return "px-8 py-3 text-lg font-semibold rounded text-th-btntext-1";
  }
}
